import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import { useSelector } from 'react-redux'
import { InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react"
import { connect } from "react-redux"
import MetaTags from 'react-meta-tags';
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle } from "reactstrap"
import { MapMarker, Map } from "react-kakao-maps-sdk";
import axios from "axios";

//FireBase
import firebase from 'firebase/compat/app'
import { initializeApp } from 'firebase/app/dist'
import { getAnalytics } from 'firebase/analytics/dist'
import { getDatabase, ref, onValue, off, set, push, child } from 'firebase/database/dist'
import { firebaseConfig } from "pages/Custom/FirebaseTool"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import { tmsCompanyResponse, tmsResponse } from "../../crud/auth.crud"

import moment from 'moment';

// 이미지
import driver from "../../assets/images/driver.png";
import truck from "../../assets/images/truck.png"
import { update } from 'lodash'

const initApp = initializeApp(firebaseConfig)
// const analytics = getAnalytics(initApp)

const TMS = () => {
  const selector = useSelector(state => state)

  const [type, setType] = useState(selector.auth.user?.type || "")
  const [memberId, setMemberId] = useState(selector.auth?.user?.id)
  const [company, setCompany] = useState(selector.auth?.user?.member_group?.[0]?.company_group.id)
  const [date, setDate] = useState(moment(new Date()).format('YYYY-MM-DD') + ' 00:00:00',)
  const [positions, setPositions] = useState([])
  const [lat, setLat] = useState()
  const [lng, setLng] = useState()
  const [collectList, setCollectList] = useState([])
  const [prevData, setPrevData] = useState(null)
  const [firebaseData, setFirebaseData] = useState(null)

  const getDataList = async () => {
    let params = {
      company: company,
      date: date,
    }
    if (type === 'emitter') {
      const param = {
        company: company,
      }
      const response = await tmsCompanyResponse(param.company)
      params = {
        company: response.data?.data?.[0]?.company,
        date: date,
      }
    }
    const rs = await tmsResponse(params)
    const tmp = []
    const tmp2 = []
    if (rs.data?.result === 'success') {
      for (let i = 0; i < rs.data?.data.length; i++) {
        let data = rs.data?.data[i];
        let item = {
          lat: parseFloat(data.x),
          lng: parseFloat(data.y),
          markerName: data.id + ''
        }
        tmp.push(item)
        let list = { company: data.company_data.name, create: data.created_at.substr(11, 8) }
        tmp2.push(list)
      }
    }
    setCollectList(tmp2)
    if(tmp.length > 0){
      getPositionList(tmp)
    }
  }

  const getPositionList = (tmp) => {
    let arr = []
    let latSum = 0
    let lngSum = 0
    for (let i = 0; i < tmp.length; i++) {
      let val = tmp[i]
      arr.push({ title: val.markerName, latlng: { lat: val.lng, lng: val.lat } })
      latSum += val.lng
      lngSum += val.lat
    }
    setPositions(arr)
    setLat(latSum / tmp.length)
    setLng(lngSum / tmp.length)
  }

  useEffect(() => {
    const db = getDatabase(initApp)
    const dbRef = ref(db, 'waste_collect/tms')
    const onDataChanged = (snapshot) => {
      const newData = snapshot.val();
      setPrevData(firebaseData)
      setFirebaseData(newData);
    }
    onValue(dbRef, onDataChanged)

    return () => {
      off(dbRef, 'value', onDataChanged)
    }
  }, [])

  useEffect(() => {
    if(prevData === null && firebaseData !== null){
      getDataList()
    }else if(prevData !== null && firebaseData !== null){
      if(firebaseData[memberId] !== prevData[memberId]){
        getDataList()
      }
    }
  }, [firebaseData])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>TMS | 웨이스트버스</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs title="홈" breadcrumbItem="TMS" breadcrumbHeaderItem='실시간 차량 이동정보 확인' />
          <Row>
            <Col lg={8} style={{ margin: '0px auto' }}>
              <Card>
                <CardBody>
                  <div
                    id="gmaps-markers"
                  >
                    <Map
                      center={{ lat: lat ? lat : 33.450936, lng: lng ? lng : 126.569477 }}
                      style={{ width: "100%", height: "100%" }}
                    >
                      {positions.map((position) => (
                        <MapMarker
                          key={`${position.title}-${position.latlng}`}
                          position={position.latlng}
                          title={position.title}
                          image={{
                            src: truck,
                            size: {
                              width: 64,
                              height: 64
                            }
                          }}
                        />
                      ))}
                    </Map>
                  </div>

                </CardBody>
              </Card>
            </Col>
            <Col lg={4} style={{ margin: '0px auto' }}>
              <Card>
                <CardBody style={{ padding: 0, borderRadius: 4, overflow: 'hidden' }}>
                  <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 265px)', overflowY: 'auto' }}>
                    <table className="table table-hover table-centered table-nowrap mb-0 chart-table">
                      <thead className="chart-thead">
                        <tr>
                          <th scope="col">수거장소</th>
                          <th scope="col">수거시각</th>
                        </tr>
                      </thead>
                      <tbody className="chart-tbody">
                        {collectList && collectList.map((item, index) => {
                          return (
                            <tr key={item.id + '_' + index}>
                              <td>{item.company}</td>
                              <td>{item.create}</td>
                            </tr>
                          )
                        })
                        }
                        {collectList.length === 0 &&
                          <tr >
                            <td colSpan="2">데이터가 없습니다.</td>
                          </tr>
                        }

                      </tbody>
                    </table>
                  </div>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TMS